import { ApiService } from "@/api";

export const aggAreaAndIndustry = () => {
  return ApiService.baseAction("agg/area/industry", {}, "GET");
};
